// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"39807776","943":"82e0244a"}[chunkId] + ".chunk.css";
};